import { MpsRoleHelper } from '../helpers/mps-role.helper';
import { MpsIRole, MpsIUser } from '../interfaces/mps-user.interface';

export class MpsUser implements MpsIUser {
  id!: number;
  firstname!: string;
  lastname!: string;
  email!: string;
  lang!: string;
  last_connection!: string;
  igg!: string;
  role_id!: number;
  avatar_url?: string | null;
  cgu_accepted_at?: string | null;

  role!: MpsRole;

  constructor(data = {}) {
    Object.assign(this, data);
  }

  isAdmin() {
    return this.isRole(MpsRoleHelper.ADMIN_IT);
  }

  /** Alias of {@link isAdmin} — kept for explicit ADMIN_IT-only call sites (spec 042). */
  isAdminIt() {
    return this.isRole(MpsRoleHelper.ADMIN_IT);
  }

  isAdminMetier() {
    return this.isRole(MpsRoleHelper.ADMIN_METIER);
  }

  isCourrierAgent() {
    return this.isRole(MpsRoleHelper.COURRIER_AGENT);
  }

  /** Any of the three staff roles (ADMIN_IT / ADMIN_METIER / COURRIER_AGENT) — excludes USER. */
  isStaff() {
    return this.isAdminIt() || this.isAdminMetier() || this.isCourrierAgent();
  }

  /**
   * Manage-map mirroring the backend `RoleController` caller-vs-target scope (spec 042):
   * ADMIN_IT can manage every role's roster; ADMIN_METIER can manage ADMIN_METIER and
   * COURRIER_AGENT (not ADMIN_IT); everyone else (including COURRIER_AGENT) can manage none.
   */
  canManageRole(targetRoleCode: string): boolean {
    const target = targetRoleCode.toUpperCase();
    if (this.isAdminIt()) {
      return true;
    }
    if (this.isAdminMetier()) {
      return target === MpsRoleHelper.ADMIN_METIER || target === MpsRoleHelper.COURRIER_AGENT;
    }
    return false;
  }

  isRole(roleCode: string) {
    return this.role?.code?.toUpperCase() === roleCode.toUpperCase();
  }
}

export class MpsRole implements MpsIRole {
  id!: number;
  label!: string;
  code!: string;

  constructor(data = {}) {
    Object.assign(this, data);
  }
}
